/**
 * Native app (Capacitor) build + runtime flags. VITE_CLIENT=native is a BUILD flag: in the browser build every
 * "if (IS_NATIVE_BUILD)" branch is constant-folded away, so no Capacitor plugin code ships to the web.
 */
export const IS_NATIVE_BUILD = import.meta.env.VITE_CLIENT === "native";
/** Push is compiled in only when the Android/iOS project has Firebase config (see apps/mobile/scripts/build-web.mjs). */
export const PUSH_BUILD = import.meta.env.VITE_PUSH === "1";
/** Build-time default API server for the native app (overridable in the hidden Server setting). */
export const DEFAULT_SERVER = String(import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "");
export const APP_VERSION = String(import.meta.env.VITE_APP_VERSION ?? "dev");
/** Version stamp of this web bundle (set by scripts/ota-bundle.mjs; "" = the web built into the APK / IPA). */
export const WEB_BUNDLE = String(import.meta.env.VITE_WEB_BUNDLE ?? "");
/** Development builds may point at http://localhost / 10.0.2.2 (Android emulator); release builds are https only. */
export const ALLOW_INSECURE_LOCAL = import.meta.env.VITE_ALLOW_INSECURE_LOCAL === "1";

type Cap = { isNativePlatform?: () => boolean; getPlatform?: () => string };
const cap = (): Cap | undefined => (typeof window === "undefined" ? undefined : (window as unknown as { Capacitor?: Cap }).Capacitor);
export const nativePlatform = (): "android" | "ios" | "web" => (cap()?.getPlatform?.() as "android" | "ios" | undefined) ?? "web";
/** True only inside the Android/iOS shell of a native build (false in a browser even for a native build). */
export const isNativeRuntime = () => IS_NATIVE_BUILD && !!cap()?.isNativePlatform?.();
